// extracted by mini-css-extract-plugin
export default {"field":"EmailRecipientField_field__9VDFT"};